import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Hero from '../components/Home/Hero'
import StatsStrip from '../components/Home/Stats'
import FleetServices from '../components/Home/FleetServices'
import HeroFleet from '../components/Home/HeroFleet'
import Carservice from '../components/Home/carservice'
import Footer from '../components/Home/Footer'
import Aboutheader from '../components/Home/Abouthistory'




const Homepage = () => {
    return (
        <div>
            <Navbar />
            <Hero />
            <StatsStrip />
            <HeroFleet />
            <FleetServices />
            <Aboutheader />
            
 
            <Carservice />
  



            <Footer />
        </div>
    )
}

export default Homepage